<template>
    <div>
        <div class="nav">
            <img class="nav-logo" src="@/assets/navLogo.png" alt="" />
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    components: {},
    created() {},
    methods: {}
};
</script>
<style lang="scss" scoped>
.nav {
    display: flex;
    align-items: center;
    padding: 12px 16px;

    .nav-logo {
        height: 40px;
        margin-right: 12px;
    }
}
</style>
